import { MetricSeriesResponse } from '@bartizo/shared';
import { apiRequest } from './client.js';

/** Time series for a chart (knowledge doc section 15). */

export interface MetricQuery {
  serverId: string;
  name: string;
  from?: string;
  to?: string;
  bucketSeconds?: number;
  /** The value "full" means for this metric: 100 for a percentage, a cap in bytes. */
  trendTarget?: number;
}

export function getMetricSeries(query: MetricQuery): Promise<MetricSeriesResponse> {
  const params = new URLSearchParams({ server_id: query.serverId, name: query.name });
  if (query.from !== undefined) params.set('from', query.from);
  if (query.to !== undefined) params.set('to', query.to);
  if (query.bucketSeconds !== undefined) params.set('bucket_seconds', String(query.bucketSeconds));
  if (query.trendTarget !== undefined) params.set('trend_target', String(query.trendTarget));

  return apiRequest(`/metrics?${params.toString()}`, { schema: MetricSeriesResponse });
}
